import {Controller} from "@hotwired/stimulus"

export default class extends Controller {

  static values = {
    fieldName: {type: String, default: 'row_checkboxes'},
    deleteBtn: {type: Boolean, default: true}
  }

  toggleCheckboxes() {
    const isChecked = this.element.checked;
    const checkboxes = document.querySelectorAll(`input[name="${this.fieldNameValue}"]`);
    checkboxes.forEach((checkbox) => {
      checkbox.checked = isChecked;
    });
    if (this.deleteBtnValue) {
      this.checkBoxLinkBtnPropChange()
    }
  }

  handleClick(event) {
    const item = event.target;
    const rowCheckboxes = document.querySelectorAll(`input[name="${this.fieldNameValue}"]`);
    event.preventDefault();
    const selectedIds = this.getRowIdFromCheckedBoxes();
    if (selectedIds.length > 0) {
      if (window.confirm("Are you sure you want to delete the rows?")) {
        var url = item.dataset.url
        let token = document.querySelector('meta[name="csrf-token"]').content;
        fetch(url, {
          method: 'POST',
          headers: {
            'X-CSRF-Token': token,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({row_ids: selectedIds})
        }).then(response => {
          if (response.ok) {
            window.location.reload();
          } else {
            console.error("Delete request failed");
          }
        })
            .catch(error => {
              console.error("Error during delete request", error);
            });
      }

    } else {
      alert('Please select any rows');
    }
  }

  getRowIdFromCheckedBoxes() {
    const rowCheckboxes = document.querySelectorAll(`input[name="${this.fieldNameValue}"]`);
    const selectedIds = Array.from(rowCheckboxes)
        .filter((checkbox) => checkbox.checked)
        .map((checkbox) => checkbox.value);
    return selectedIds

  }

  checkBoxLinkBtnPropChange() {
    const button = document.querySelector('[data-name="delete_row"]')
    const selectedIds = this.getRowIdFromCheckedBoxes();
    if (selectedIds.length > 0) {
      button.classList.remove("opacity-50", "cursor-not-allowed")
    } else {
      button.classList.add("opacity-50", "cursor-not-allowed")
    }
  }


}
